module.exports = __webpack_public_path__ + "static/media/3DPPA10.09d39029.jpg";